import React, { useState, useEffect } from 'react';
import CallHistoryTab from '@/components/voicemail/CallHistoryTab';

const CallHistoryPage = () => {
  useEffect(() => {
    document.title = "Call History | Admin";
  }, []);

  // Shared state for rows per page
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  return (
    <div className="min-h-screen bg-background">
      <main className="mx-auto">
        <CallHistoryTab 
          recordsPerPage={recordsPerPage}
          onRecordsPerPageChange={setRecordsPerPage}
        />
      </main>
    </div>
  );
};

export default CallHistoryPage;
